import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const GetStarted = () => {
  const [mousePosition, setMousePosition] = useState({ x: 0, y: 0 });
  const [isVisible, setIsVisible] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    setIsVisible(true);
    
    const handleMouseMove = (e) => {
      setMousePosition({
        x: (e.clientX / window.innerWidth) * 100,
        y: (e.clientY / window.innerHeight) * 100,
      });
    };

    window.addEventListener('mousemove', handleMouseMove);
    return () => window.removeEventListener('mousemove', handleMouseMove);
  }, []);

  const handleGetStarted = () => {
    navigate('/contact');
  };

  const handleLearnMore = () => {
    const nextSection = document.querySelector('#next-section');
    if (nextSection) {
      nextSection.scrollIntoView({ 
        behavior: 'smooth',
        block: 'start'
      });
    }
  };

  return (
    <div className="relative isolate px-6 lg:px-8 flex items-center overflow-hidden min-h-screen ">
      {/* Background animé avec dégradé qui suit la souris */}
      <div 
        className="absolute inset-0 bg-gradient-to-br from-indigo-50/70 via-white to-blue-50/50 transition-all duration-1000 ease-out"
        style={{
          background: `radial-gradient(circle at ${mousePosition.x}% ${mousePosition.y}%, rgba(99, 102, 241, 0.1) 0%, rgba(255, 255, 255, 0.9) 30%, rgba(147, 197, 253, 0.05) 100%)`
        }}
      ></div>
      
      


      
      <div className={`relative mx-auto max-w-2xl py-20 sm:py-24 lg:py-32 w-full transition-all duration-1500 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}>
        {/* Badge avec effet glassmorphism */}
        <div className={`hidden sm:mb-8 sm:flex sm:justify-center transition-all duration-1000 delay-300 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4'}`}>
          <div className="relative rounded-full px-4 py-2 text-sm leading-6 text-slate-700 ring-1 ring-indigo-200/50 bg-white/40 backdrop-blur-sm hover:bg-white/60 hover:ring-indigo-300/60 transition-all duration-300 shadow-lg hover:shadow-xl">
            <div className="absolute inset-0 rounded-full bg-gradient-to-r from-indigo-500/10 to-blue-500/10"></div>
            <span className="relative">
              Automatisez et personnalisez vos emails.{' '}
              <a href="#" className="font-semibold text-indigo-600 hover:text-indigo-700 group">
                En savoir plus 
                <span className="inline-block transition-transform group-hover:translate-x-1 ml-1" aria-hidden="true">→</span>
              </a>
            </span>
          </div>
        </div>
        
        <div className="text-center top-0 pb-40">
          {/* Titre avec effet de frappe et dégradé */}
          <h1 className={`text-5xl font-bold tracking-tight sm:text-7xl transition-all duration-1000 delay-500 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}>
            <span className="relative inline-block">
              <span className="bg-gradient-to-r from-indigo-600 via-purple-600 to-indigo-800 bg-clip-text text-transparent animate-pulse">
                Accélérez
              </span>
              {/* Effet de brillance qui passe */}
              <span className="absolute inset-0 bg-gradient-to-r from-transparent via-white/30 to-transparent skew-x-12 animate-shine"></span>
            </span>
            {' '}
            <span className="text-slate-900 relative">
              Vos Recrutements !
            </span>
          </h1>
          
          <p className={`mt-6 text-lg text-slate-600 sm:text-xl leading-8 transition-all duration-1000 delay-700 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'}`}>
            <span className="relative">
              Gérez votre base de données. Envoyez des emails groupés. Importez des profils depuis LinkedIn. Centralisez toutes vos tâches.
            </span>
          </p>
          
          <div className={`mt-10 flex items-center justify-center gap-x-6 transition-all duration-1000 delay-900 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4'}`}>
            {/* Bouton principal avec effets multiples */}
            <button 
              onClick={handleGetStarted}
              className="relative group bg-gradient-to-r from-indigo-600 to-indigo-700 hover:from-indigo-700 hover:to-indigo-800 text-white px-8 py-4 rounded-xl font-semibold transition-all duration-300 shadow-lg hover:shadow-2xl transform hover:-translate-y-1 hover:scale-105 overflow-hidden"
            >
              {/* Effet de vague au hover */}
              <span className="absolute inset-0 bg-gradient-to-r from-transparent via-white/20 to-transparent translate-x-[-100%] group-hover:translate-x-[100%] transition-transform duration-700 skew-x-12"></span>
              <span className="relative flex items-center">
                <span>Commencer</span>
                <svg className="ml-2 w-4 h-4 transition-transform group-hover:translate-x-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 7l5 5m0 0l-5 5m5-5H6" />
                </svg>
              </span>
              {/* Particules au hover */}
              <div className="absolute inset-0 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                {[...Array(6)].map((_, i) => (
                  <div
                    key={i}
                    className="absolute w-1 h-1 bg-white rounded-full animate-ping"
                    style={{
                      left: `${20 + Math.random() * 60}%`,
                      top: `${20 + Math.random() * 60}%`,
                      animationDelay: `${Math.random() * 0.5}s`,
                    }}
                  ></div>
                ))}
              </div>
            </button>
            
            {/* Bouton secondaire avec effet de soulignement */}
            <button 
              onClick={handleLearnMore}
              className="group text-slate-700 hover:text-indigo-600 font-semibold transition-all duration-300 relative "
            >
              <span className="relative">
                En savoir plus
                <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-indigo-600 transition-all duration-300 group-hover:w-full"></span>
              </span>
              <span className="inline-block transition-transform group-hover:translate-x-1 ml-2">→</span>
            </button>
          </div>
        </div>
      </div>

      {/* Styles personnalisés pour les animations */}
      <style>{`
        @keyframes shine {
          0% { transform: translateX(-100%) skewX(12deg); }
          100% { transform: translateX(200%) skewX(12deg); }
        }

        @keyframes expand-width {
          0% { width: 0%; }
          100% { width: 100%; }
        }

        @keyframes blink {
          0%, 50% { opacity: 1; }
          51%, 100% { opacity: 0; }
        }

        .animate-shine {
          animation: shine 3s ease-in-out infinite;
          animation-delay: 2s;
        }

        .animate-expand-width {
          animation: expand-width 2s ease-out forwards;
          animation-delay: 1.5s;
        }

        .animate-blink {
          animation: blink 1s step-end infinite;
        }
      `}</style>
    </div>
  );
};

export default GetStarted;